<div class="text-center px-3 pb-3">
    <p class="text-center text-base font-medium mt-6 mb-1">{{jobs}} {{'jobs.selected' | translate}}</p>
    <a mat-stroked-button
        class="inline-flex items-center px-4 py-3 mt-4 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
        <em class="text-xl" class="ti ti-plus text-xl"></em><span
            class="ml-2 primary-font text-base leading-loose pt-0.5" (click)="createRouteClicked()">{{"route.create" | translate}}</span>
    </a>
</div>
